import React from "react";

const Group = () => {
    return (
        <svg
            className="ml-auto mt-3"
            width="58"
            height="52"
            viewBox="0 0 62 57"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                width="61.622"
                height="56.6929"
                rx="6"
                fill="#A29AF9"
                fill-opacity="0.2"
            />
            <g clip-path="url(#clip0_1_676)">
                <path
                    d="M20.3308 20.4689C23.7686 20.4689 26.5651 17.672 26.5651 14.2345C26.5651 10.7966 23.7683 8 20.3308 8C16.8933 8 14.0963 10.7966 14.0963 14.2344C14.0963 17.6719 16.893 20.4689 20.3308 20.4689ZM41.7758 24.318C43.4936 24.318 44.8904 22.9213 44.8904 21.2047V19.1086C42.7176 19.0282 40.5587 18.7251 38.4478 18.2041V20.9898C38.4475 22.8284 39.9353 24.318 41.7758 24.318V24.318ZM30.9987 37.0936C26.8926 37.0936 23.5522 40.4344 23.5522 44.5405V46.8281C23.5522 47.4754 24.0768 48 24.724 48H37.2759C37.9232 48 38.4478 47.4754 38.4478 46.8281V44.5417C38.4478 40.435 35.1067 37.0936 30.9987 37.0936Z"
                    fill="#9C94F2"
                />
                <path
                    d="M21.2084 44.5405C21.2084 40.7115 23.4182 37.3894 26.6293 35.7811C24.4741 34.3571 23.0496 31.9136 23.0496 29.1432C23.0496 27.1944 23.7548 25.4075 24.9227 24.0233C23.5662 23.253 21.9991 22.8123 20.3308 22.8123C15.1858 22.8127 11 26.9981 11 32.143V46.8281C11 47.4754 11.5246 48 12.1719 48H21.4098C21.2764 47.6237 21.2083 47.2274 21.2084 46.8281V44.5405Z"
                    fill="#9C94F2"
                />
                <path
                    d="M31 34.7498C34.0917 34.7498 36.6067 32.2346 36.6067 29.1432C36.6067 26.0518 34.0917 23.5365 31 23.5365C27.9083 23.5365 25.3933 26.0518 25.3933 29.1432C25.3933 32.2349 27.9083 34.7498 31 34.7498ZM41.6692 26.6618C40.6586 26.661 39.6545 26.825 38.6966 27.1473C38.8656 27.7992 38.9509 28.4698 38.9505 29.1432C38.9505 31.9139 37.5256 34.3577 35.3701 35.7814C38.5815 37.3902 40.7916 40.7124 40.7916 44.5417V46.8281C40.7916 47.2389 40.7202 47.6332 40.5902 48H49.8282C50.4754 48 51 47.4754 51 46.8281V35.9926C51 30.8476 46.8142 26.6618 41.6692 26.6618ZM41.6696 8C36.5242 8 32.3383 12.1858 32.3383 17.3313V21.3059C34.0821 21.6026 35.6339 22.469 36.7953 23.7062C36.3443 22.8825 36.1039 21.9548 36.1039 20.9898V16.7031C36.1041 16.5251 36.1447 16.3494 36.2229 16.1894C36.301 16.0294 36.4146 15.8893 36.555 15.7798C36.6953 15.6703 36.8588 15.5941 37.033 15.5572C37.2071 15.5203 37.3874 15.5235 37.5602 15.5666L38.9282 15.9087C41.2616 16.4917 43.6575 16.7866 46.0626 16.7867C46.7093 16.7867 47.2345 17.3119 47.2345 17.9586V21.2047C47.2345 22.69 46.6367 24.0392 45.6712 25.0243C46.7485 25.4197 47.7617 25.9715 48.6783 26.6619H49.8282C50.4751 26.6619 51 26.1366 51 25.49V17.3314C51 12.1858 46.8142 8 41.6696 8Z"
                    fill="#9C94F2"
                />
            </g>
            <defs>
                <clipPath id="clip0_1_676">
                    <rect
                        width="40"
                        height="40"
                        fill="white"
                        transform="translate(11 8)"
                    />
                </clipPath>
            </defs>
        </svg>
    )
}

export default Group;